module.exports = __webpack_public_path__ + "static/media/popular.08efca11.jpg";